import { parseTzFormattedDateTime, parseTzFormattedDate } from '@ninja/utilities';

const parse = (viewMode, enableTimeSelection) => {
    switch (viewMode) {
        case 'time':
            return (value, format, calendar, unMaskedDate) => parseTzFormattedDate(value, 'HH:mm', calendar, unMaskedDate);
        case 'months':
            return (value, format, calendar, unMaskedDate) => parseTzFormattedDate(value, 'MM/yyyy', calendar, unMaskedDate);
        case 'years':
            return (value, format, calendar, unMaskedDate) => parseTzFormattedDate(value, 'yyyy', calendar, unMaskedDate);
        case 'days':
        default:
            return enableTimeSelection ? parseTzFormattedDateTime : parseTzFormattedDate;
    }
};

export { parse };
